<template>
    <div>
        <div class="dropdown-area">
            <div class="button noselect" tabindex="0" v-on:click="onClicked($event)">
                <img v-if="typeof imgSrc !== 'undefined'" :src="imgSrc" alt="">
                <div class="btnTxt">{{btnTxt}}</div>
            </div>
            <ol v-show="buttonChecked===true" class="dropdown">
                <li v-for="(item, index) in dropdownData" :key="item.name"
                    :class="index===0? '':'li-breaker'"
                    v-on:click="onClicked($event,item.name)">
                    {{item.name}}
                </li>
            </ol>
        </div>
    </div>
</template>

<script>

    export default {
        name: "BBtnDropDown",
        props: {
            imgSrc: String,
            btnTxt: String,
            clicked: Function,
            hiddenKey: String,
            disabled: String,
            dropdownData: Array,
        },
        data() {
            return {
                buttonChecked: false,
            }
        },
        methods: {
            onClicked(event, value) {
                if(this.disabled === "true"){
                    return;
                }
                let width = event.target.parentElement.clientWidth;
                let dropdown = event.target.parentElement.parentElement.getElementsByClassName("dropdown")[0];
                let w = width + "px";
                dropdown.style.width = w;
                if (typeof this.clicked === 'function' && typeof value !== "undefined") {
                    this.clicked(value);
                }

                if (this.buttonChecked === false) {
                    this.buttonChecked = true;
                } else {
                    this.buttonChecked = false;
                }
            },
        }
    }
</script>

<style scoped>

    .dropdown-area {
        width: 100%;
    }

    .button {
        display: flex;
        /*width: 110px;*/
        height: 38px;
        background: #0171A3;
        border-radius: 5px;
        color: #FEFEFE;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 14px;
        padding: 0 1em;
        outline: none;
        z-index: 10;
    }

    .button img {
        width: 18px;
        height: 18px;
        margin-right: 5px;
    }

    .btnTxt {
        margin: 0 0px;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                         supported by Chrome and Opera */
    }

    :focus {
        outline: none;
    }

    .button:hover,
    .button:focus {
        background: #018AC7;
    }

    .button:active {
        background: #018AC7;
    }

    .dropdown {
        position: absolute;
        z-index: 9;
        border-radius: 5px;
        background: #FFFFFF;
        box-shadow: 0px 8px 21px 0px rgba(169, 169, 169, 0.26);
    }

    .dropdown li {
        list-style-type: none;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666666;
        cursor: pointer;
    }

    .dropdown li:hover{
        background: rgba(250, 249, 249, 0.99);
    }

    .li-breaker {
        border-top: 1px solid #ECECEC;
    }

</style>